import config from '../../../config'
import http from './http-util'

import 'formdata-polyfill'

class PaymentServiceProxyApi {
  static getPaymentInfo = (id, token) => {
    return http.get(
      token,
      `${config.paymentServiceProxyUrl}/store/${id}/payment_info`,
    )
  }
}

export default PaymentServiceProxyApi
